/* src/app/components/session-info/parking-text/parking-text.component.scss */
/*# sourceMappingURL=parking-text.component.css.map */
